angular.module('charts')
    .directive('dblStudentProficiencyOverview', ['$filter', 'localeService', function($filter, localeService) {
    // dbl-student-proficiency-overview is a component that diplays a table
    // where columns are levels, and each
    // cell shows proficiency and growth for a domain.  AKA the Tetris grid.

    var MIN_ARROW_THRESHOLD = 13;

    return {
        restrict: 'E',
        scope: {
            dblProficiencies: '=',
            dblGradeLevel: '=',
            dblShowPercent: '=',
            dblShowPlacement: '='
        },
        templateUrl: '/resources/charts/directives/student-proficiency-overview/dbl-student-proficiency-overview.directive.html',
        link: function(scope, element) {
            var standardsProficientText = '';
            var placementColor = '#B4DEA2';
            var proficiencyColor = '#6ABD45';
            var growthColor = '#559737';
            var highlightColor = 'rgba(135, 190, 220, 0.3)';
            var notAvailableColor = '#F5F5F5';

            var getCellClasses = function (cell, isFirstRow, isLastRow) {
                var classes = [];
                if (cell.moProficiencyPercent !== undefined) {
                    classes.push('domain-available');
                }

                if (cell.standards) {
                    classes.push('has-standards');
                }

                if (scope.dblGradeLevel === cell.grade) {
                    classes.push('current-grade-level');

                    if (isFirstRow) {
                        classes.push('first-domain');
                    }

                    if (isLastRow) {
                        classes.push('last-domain');
                    }
                } else if (scope.dblGradeLevel === cell.grade - 1) {
                    // Grade after current needs class so it's left border
                    // doesn't override highlight of current.
                    // Might be able to avoid these extra grade level classes by using
                    // border-style: double on current-grade-level class.
                    classes.push('next-grade-level');
                } else if (scope.dblGradeLevel === cell.grade + 1) {
                    // Grade before current needs class so it's right border
                    // doesn't override highlight of current.
                    classes.push('previous-grade-level');
                }

                return classes.join(' ');
            };

            var createColorString = function (color, start, stop) {
                return color + ' ' + start + '%, ' + color + ' ' + stop + '%';
            };

            var buildColorList = function (cell) {
                // Only add colors to the list if they span a positive amount
                // of space.  (Chrome print preview would show proficiency coloring even
                // when it started and stopped at zero percent)

                var colorList = [];
                var endPercentOfPreviousColor = 0;

                // placement
                if (scope.dblShowPlacement && cell.__view.placement > endPercentOfPreviousColor) {
                    colorList.push(createColorString(
                        placementColor,
                        endPercentOfPreviousColor,
                        cell.__view.placement
                    ));

                    endPercentOfPreviousColor = cell.__view.placement;
                }

                // proficiency
                if (cell.__view.startOfGrowth > endPercentOfPreviousColor) {
                    colorList.push(createColorString(
                        proficiencyColor,
                        endPercentOfPreviousColor,
                        cell.__view.startOfGrowth
                    ));

                    endPercentOfPreviousColor = cell.__view.startOfGrowth;
                }

                // growth
                if (cell.__view.endOfGrowth > endPercentOfPreviousColor) {
                    colorList.push(createColorString(
                        growthColor,
                        endPercentOfPreviousColor,
                        cell.__view.endOfGrowth
                    ));

                    endPercentOfPreviousColor = cell.__view.endOfGrowth;
                }

                // available
                if (endPercentOfPreviousColor < 100) {
                    colorList.push(createColorString(
                        'white',
                        endPercentOfPreviousColor,
                        100
                    ));
                }

                return colorList;
            };

            // Background styles dynamicaly generated instead of using css classes because
            // proficiency is shown using background gradient with varying percent.
            // Doing this on ng-attr-style instead of ng-style because ng-style doesn't
            // support !important.  !important is needed because top level print css
            // clears all backgrounds.
            var  getCellStyle = function (cell) {
                var backgrounds = [];
                var backgroundRepeats = [];

                // Current grade level highlight
                if (scope.dblGradeLevel === cell.grade) {
                    var currentGradeHighlight = 'linear-gradient(' + highlightColor + ', ' + highlightColor + ')';
                    backgrounds.push(currentGradeHighlight);
                    backgroundRepeats.push('repeat');
                }

                if (cell.moProficiencyPercent !== undefined) {
                    // generate color blocks
                    var colorList = buildColorList(cell);

                    // linear-gradient(90deg, #5BB335 0%, #5BB335 42%, ... , white 80%, white 100%)
                    var progressColoring = 'linear-gradient(90deg, ';

                    progressColoring += colorList.join(', ');
                    progressColoring += ')';

                    backgrounds.push(progressColoring);
                    backgroundRepeats.push('no-repeat'); // prevents color from starting again on right border
                } else {
                    // domain/level combination doesn't exist
                    backgrounds.push('linear-gradient(90deg, ' + createColorString(notAvailableColor, 1, 99) + ')');
                    backgroundRepeats.push('no-repeat');
                }

                var style = 'background: ' +  backgrounds.join(',') + ' !important';

                if (backgroundRepeats.length) {
                    style += ';background-repeat: ' + backgroundRepeats.join(',') + ' !important';
                }

                return style;
            };

            var calculatePositions = function (tableData) {
                // For each cell adjust percentages so arrows never get too small
                // or overlap adjacent cells.
                _.each(tableData.rows, function (row) {
                    _.each(row.levels, function (cell) {

                        var percents = {};

                        if (cell.moProficiencyPercent !== undefined) {
                            percents.placement = Math.round(cell.moPlacementPercent);
                            percents.endOfGrowth = Math.round(cell.moEndOfGrowthPercent);
                            percents.startOfGrowth = Math.round(cell.moStartOfGrowthPercent);
                            percents.proficiency = Math.round(cell.moProficiencyPercent);

                            if (cell.playMoGrowthPercent > 0) {
                                if (percents.endOfGrowth < MIN_ARROW_THRESHOLD) {
                                    // Small growth arrow up against left side of cell
                                    percents.placement = 0;
                                    percents.proficiency = 0;
                                    percents.startOfGrowth = 0;
                                    percents.endOfGrowth = MIN_ARROW_THRESHOLD;
                               } else if (percents.endOfGrowth - percents.startOfGrowth < MIN_ARROW_THRESHOLD) {
                                    // Small growth elsewhere in the cell.  Here we adjust the start of growth,
                                    // leaving the end of growth in place to give an accurate picture of the remaining
                                    // work in the domain.
                                    percents.startOfGrowth = percents.endOfGrowth - MIN_ARROW_THRESHOLD;
                                    percents.placement = Math.min(percents.placement, percents.startOfGrowth);
                                }
                            }

                            percents.growth = percents.endOfGrowth - percents.startOfGrowth;
                        }

                        cell.__view = percents;
                    });
                });
            };

            var addStyles = function (tableData) {
                _.each(tableData.rows, function (row, rowIndex) {
                    _.each(row.levels, function (cell) {
                        cell.__view.classes = getCellClasses(cell, rowIndex === 0, rowIndex === tableData.rows.length - 1);
                        cell.__view.style = getCellStyle(cell);
                    });
                });
            };

            scope.$watch('dblProficiencies', function (newVal) {
                if (newVal) {
                    if (localeService.getLocale() === 'en-gb') {
                        for (var i = 0; i < newVal.columns.length; i++) {
                            newVal.columns[i].grade++;
                        }
                    }
                    scope.columns = newVal.columns;
                    scope.rows = newVal.rows;

                    calculatePositions(newVal);
                    addStyles(newVal);

                    standardsProficientText = $filter('domainText')(' Standards Proficient', newVal.astName);
                } else {
                    scope.columns = undefined;
                    scope.rows = undefined;
                }
            });

            scope.$watch('dblGradeLevel', function (newVal) {
                // Update styles to reflect new grade level
                if (newVal && scope.dblProficiencies) {
                    addStyles(scope.dblProficiencies);
                }
            });

            scope.getCellTitle = function (cell) {
                if (scope.dblShowPercent === true) {
                    if (cell.percentStandardsComplete === undefined || cell.percentStandardsComplete === null) {
                        return '';
                    }

                    return $filter('percent')(cell.percentStandardsComplete, 0) + standardsProficientText;
                }

                if (cell.standards_count === undefined || cell.standards_count === null) {
                    return '';
                }

                return cell.standards_completed + '/' + cell.standards_count + standardsProficientText;
            };

            scope.getShowHead = function (cell) {
                if (!cell.__view.growth) {
                     return false;
                }

                return cell.__view.growth && !cell.growthContinuedToNext;
            };

            scope.getStartPercent = function (cell) {
                return cell.__view.startOfGrowth;
            };

            scope.getEndPercent = function (cell) {
                return cell.__view.endOfGrowth;
            };
        }
    };
}]);
